<template>
  <section class="flex flex-col">
    <div class="video relative pt-15.625">
      <video
          class="w-screen"
          style="z-index: -10; -webkit-mask-image:radial-gradient(circle at center,#000 33%,transparent 70%);"
          autoplay
          loop
          muted
          src="@/assets/videos/agency.mp4"
      ></video>
    </div>
    <div class="flex flex-col mx-4.5 ">
      <div class="header flex items-center justify-between">
        <p class="fz-18 font-medium uppercase" style="line-height: 1.666;color: rgba(50, 55, 73, 1)">/ {{ text.slide1.AGENCY }}</p>
        <img class="h-10 w-10" src="@/assets/images/slide_2/about/team.svg" alt="">
      </div>
      <div class="flex flex-col mt-12.5 gap-y-7.5">
          <hr class="h-px w-full" style="border-color:rgba(151, 163, 203, 0.3);">
          <div class="flex flex-col">
              <span class="text-accent fz-10 mb-2.5 font-medium uppercase" style="line-height:2;">{{text.slide1.we}}</span>
              <p class="fz-16" style="line-height: 1.875">{{text.slide1.team}}</p>
          </div>
          <hr class="h-px w-full" style="border-color:rgba(151, 163, 203, 0.3);">
          <div class="flex flex-col">
              <span class="text-accent fz-10 mb-2.5 font-medium uppercase" style="line-height:2;">{{text.slide1.task[0]}}</span>
              <p class="fz-16" style="line-height: 1.875">{{text.slide1.task[1]}}</p>
          </div>
          <hr class="h-px w-full" style="border-color:rgba(151, 163, 203, 0.3);">
      </div>
      <p class="my-25 fz-16 text-light-gray">{{text.slide1.text}} {{text.slide1.link}}</p>
      <h3 class="fz-22 text-gray" style="line-height:1.3636">{{text.slide2.maxTextTitle}}</h3>
      <p class="mt-12.5 fz-16" style="line-height:1.875">{{text.slide2.maxText}}</p>
      <div class="need-of-digital-solutions flex flex-col my-25 gap-y-7 5">
        <hr class="h-px w-full" style="border-color:rgba(151, 163, 203, 0.3);">
        <div>
          <picture>
            <svg class="w-10 h-10 mb-5" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M38.75 26.25C38.75 27.3551 38.311 28.4149 37.5296 29.1963C36.7482 29.9777 35.6884 30.4167 34.5833 30.4167H9.58333L1.25 38.75V5.41667C1.25 4.3116 1.68899 3.25179 2.47039 2.47039C3.25179 1.68899 4.3116 1.25 5.41667 1.25H34.5833C35.6884 1.25 36.7482 1.68899 37.5296 2.47039C38.311 3.25179 38.75 4.3116 38.75 5.41667V26.25Z" stroke="#FF2E53" stroke-opacity="1" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
              <path d="M9.5 11.5H30" stroke="#FF2E53" stroke-opacity="1" stroke-width="2"></path>
              <path d="M10 20H21" stroke="#FF2E53" stroke-opacity="1" stroke-width="2"></path>
            </svg>
          </picture>
          <h4 class="fz-22 text-accent" style="line-height: 1.3636;">{{text.slide2.needDigital}}</h4>
        </div>
        <p class=" fz-16" style="line-height:1.875">{{text.slide2.myTask}}</p>
        <hr class="h-px w-full" style="border-color:rgba(151, 163, 203, 0.3);">
      </div>
      <div class="mb-25 past-partners">
        <picture>
          <svg class="w-10 mb-5" viewBox="0 0 32 36" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path stroke-opacity="0.3" d="M17.6667 1.33333L1 21.3333H16L14.3333 34.6667L31 14.6667H16L17.6667 1.33333Z" stroke="#97A3CB" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
          </svg>
        </picture>
        <p class="text-light-gray fz-18" style="line-height:1.666">{{text.slide3.text[0]}}</p>
      </div>
      <div class="mb-25 main-rule">
        <h4 class="fz-22 text-accent mb-12.5" style="line-height: 1.3636;">{{text.slide3.mainRule}}</h4>
        <p class=" fz-16" style="line-height:1.875">{{text.slide3.text[1]}}</p>
      </div>


      <div class="services-list mb-25">
        <h4 class="fz-22 text-gray mb-12.5" style="line-height: 1.3636;">{{text.slide4.what}}</h4>
        <section class="services fz-16 font-medium gap-y-5 flex flex-col">
          <div
            class="service-m flex flex-col p-7.5"
          >
            <div class="flex items-center justify-between">
              <img
                class="w-12.5 h-12.5"
                src="@/assets/images/slide_1/service_icons/loader.svg"
                alt=""
              />
              <p class="fz-18 uppercase" style="line-height: 1.666rem">{{ text.slide4.services[0].title }}</p>
            </div>
            <div
              class="dop overflow-hidden grid grid-rows-3 grid-cols-1 gap-1.25 h-31.25 pt-2.5 pb-7.5">
              <div class="flex items-center ml-auto justify-end">
                <p class="mr-5" style="line-height: 1.5625">{{ text.slide4.services[0].points[0] }}</p>
                <div class="w-5 h-5 relative">
                  <div
                    class="w-px h-4 absolute top-0.5 left-1/2 transform -translate-x-1/2"
                    style="background: rgba(110, 117, 141, 1)"
                  ></div>
                  <div
                    class="h-px w-4 absolute left-0.5 top-1/2 transform -translate-y-1/2"
                    style="background: rgba(110, 117, 141, 1)"
                  ></div>
                </div>
              </div>
              <div class="flex items-center ml-auto justify-end">
                <p class="mr-5" style="line-height: 1.5625">{{ text.slide4.services[0].points[1] }}</p>
                <div class="w-5 h-5 relative">
                  <div
                    class="w-px h-4 absolute top-0.5 left-1/2 transform -translate-x-1/2"
                    style="background: rgba(110, 117, 141, 1)"
                  ></div>
                  <div
                    class="h-px w-4 absolute left-0.5 top-1/2 transform -translate-y-1/2"
                    style="background: rgba(110, 117, 141, 1)"
                  ></div>
                </div>
              </div>
              <div class="flex items-center ml-auto justify-end">
                <p class="mr-5" style="line-height: 1.5625">{{ text.slide4.services[0].points[2] }}</p>
                <div class="w-5 h-5 relative">
                  <div
                    class="w-px h-4 absolute top-0.5 left-1/2 transform -translate-x-1/2"
                    style="background: rgba(110, 117, 141, 1)"
                  ></div>
                  <div
                    class="h-px w-4 absolute left-0.5 top-1/2 transform -translate-y-1/2"
                    style="background: rgba(110, 117, 141, 1)"
                  ></div>
                </div>
              </div>
            </div>
          </div>

          <div
            class="service-m flex flex-col p-7.5"
          >
            <div class="flex items-center justify-between">
              <img
                class="w-12.5 h-12.5"
                src="@/assets/images/slide_1/service_icons/globe.svg"
                alt=""
              />
              <p class="fz-18 uppercase" style="line-height: 1.666rem">{{ text.slide4.services[1].title }}</p>
            </div>
            <div
              class="dop overflow-hidden grid grid-rows-3 grid-cols-1 gap-1.25 h-31.25 pt-2.5 pb-7.5">
              <div class="flex items-center ml-auto justify-end">
                <p class="mr-5" style="line-height: 1.5625">{{ text.slide4.services[1].points[0] }}</p>
                <div class="w-5 h-5 relative">
                  <div
                    class="w-px h-4 absolute top-0.5 left-1/2 transform -translate-x-1/2"
                    style="background: rgba(110, 117, 141, 1)"
                  ></div>
                  <div
                    class="h-px w-4 absolute left-0.5 top-1/2 transform -translate-y-1/2"
                    style="background: rgba(110, 117, 141, 1)"
                  ></div>
                </div>
              </div>
              <div class="flex items-center ml-auto justify-end">
                <p class="mr-5" style="line-height: 1.5625">{{ text.slide4.services[1].points[1] }}</p>
                <div class="w-5 h-5 relative">
                  <div
                    class="w-px h-4 absolute top-0.5 left-1/2 transform -translate-x-1/2"
                    style="background: rgba(110, 117, 141, 1)"
                  ></div>
                  <div
                    class="h-px w-4 absolute left-0.5 top-1/2 transform -translate-y-1/2"
                    style="background: rgba(110, 117, 141, 1)"
                  ></div>
                </div>
              </div>
              <div class="flex items-center ml-auto justify-end">
                <p class="mr-5" style="line-height: 1.5625">{{ text.slide4.services[1].points[2] }}</p>
                <div class="w-5 h-5 relative">
                  <div
                    class="w-px h-4 absolute top-0.5 left-1/2 transform -translate-x-1/2"
                    style="background: rgba(110, 117, 141, 1)"
                  ></div>
                  <div
                    class="h-px w-4 absolute left-0.5 top-1/2 transform -translate-y-1/2"
                    style="background: rgba(110, 117, 141, 1)"
                  ></div>
                </div>
              </div>
            </div>
          </div>

          <div
            class="service-m flex flex-col p-7.5"
          >
            <div class="flex items-center justify-between">
              <img
                class="w-12.5 h-12.5"
                src="@/assets/images/slide_1/service_icons/radio.svg"
                alt=""
              />
              <p class="fz-18 uppercase" style="line-height: 1.666rem">
                {{ text.slide4.services[2].title }}
              </p>
            </div>
            <div
              class="dop overflow-hidden grid grid-rows-3 grid-cols-1 gap-1.25 h-31.25 pt-2.5 pb-7.5">
              <div class="flex items-center ml-auto justify-end">
                <p class="mr-5" style="line-height: 1.5625">{{ text.slide4.services[2].points[0] }}</p>
                <div class="w-5 h-5 relative">
                  <div
                    class="w-px h-4 absolute top-0.5 left-1/2 transform -translate-x-1/2"
                    style="background: rgba(110, 117, 141, 1)"
                  ></div>
                  <div
                    class="h-px w-4 absolute left-0.5 top-1/2 transform -translate-y-1/2"
                    style="background: rgba(110, 117, 141, 1)"
                  ></div>
                </div>
              </div>
              <div class="flex items-center ml-auto justify-end">
                <p class="mr-5" style="line-height: 1.5625">{{ text.slide4.services[2].points[1] }}</p>
                <div class="w-5 h-5 relative">
                  <div
                    class="w-px h-4 absolute top-0.5 left-1/2 transform -translate-x-1/2"
                    style="background: rgba(110, 117, 141, 1)"
                  ></div>
                  <div
                    class="h-px w-4 absolute left-0.5 top-1/2 transform -translate-y-1/2"
                    style="background: rgba(110, 117, 141, 1)"
                  ></div>
                </div>
              </div>
              <div class="flex items-center ml-auto justify-end">
                <p class="mr-5" style="line-height: 1.5625">{{ text.slide4.services[2].points[2] }}</p>
                <div class="w-5 h-5 relative">
                  <div
                    class="w-px h-4 absolute top-0.5 left-1/2 transform -translate-x-1/2"
                    style="background: rgba(110, 117, 141, 1)"
                  ></div>
                  <div
                    class="h-px w-4 absolute left-0.5 top-1/2 transform -translate-y-1/2"
                    style="background: rgba(110, 117, 141, 1)"
                  ></div>
                </div>
              </div>
            </div>
          </div>

          <div
            class="service-m flex flex-col p-7.5">
            <div class="flex items-center justify-between">
              <img
                class="w-12.5 h-12.5"
                src="@/assets/images/slide_1/service_icons/pen-tool.svg"
                alt=""
              />
              <p class="fz-18 uppercase" style="line-height: 1.666rem">{{ text.slide4.services[3].title }}</p>
            </div>
            <div
              class="dop overflow-hidden grid grid-rows-3 grid-cols-1 gap-1.25 h-31.25 pt-2.5 pb-7.5">
              <div class="flex items-center ml-auto justify-end">
                <p class="mr-5" style="line-height: 1.5625">{{ text.slide4.services[3].points[0] }}</p>
                <div class="w-5 h-5 relative">
                  <div
                    class="w-px h-4 absolute top-0.5 left-1/2 transform -translate-x-1/2"
                    style="background: rgba(110, 117, 141, 1)"
                  ></div>
                  <div
                    class="h-px w-4 absolute left-0.5 top-1/2 transform -translate-y-1/2"
                    style="background: rgba(110, 117, 141, 1)"
                  ></div>
                </div>
              </div>
              <div class="flex items-center ml-auto justify-end">
                <p class="mr-5" style="line-height: 1.5625">{{ text.slide4.services[3].points[1] }}</p>
                <div class="w-5 h-5 relative">
                  <div
                    class="w-px h-4 absolute top-0.5 left-1/2 transform -translate-x-1/2"
                    style="background: rgba(110, 117, 141, 1)"
                  ></div>
                  <div
                    class="h-px w-4 absolute left-0.5 top-1/2 transform -translate-y-1/2"
                    style="background: rgba(110, 117, 141, 1)"
                  ></div>
                </div>
              </div>
              <div class="flex items-center ml-auto justify-end">
                <p class="mr-5" style="line-height: 1.5625">{{ text.slide4.services[3].points[2] }}</p>
                <div class="w-5 h-5 relative">
                  <div
                    class="w-px h-4 absolute top-0.5 left-1/2 transform -translate-x-1/2"
                    style="background: rgba(110, 117, 141, 1)"
                  ></div>
                  <div
                    class="h-px w-4 absolute left-0.5 top-1/2 transform -translate-y-1/2"
                    style="background: rgba(110, 117, 141, 1)"
                  ></div>
                </div>
              </div>
            </div>
          </div>

          <div
            class="service-m flex flex-col p-7.5">
            <div class="flex items-center justify-between">
              <img
                class="w-12.5 h-12.5"
                src="@/assets/images/slide_1/service_icons/smile.svg"
                alt=""
              />
              <p class="fz-18 uppercase" style="line-height: 1.666rem">{{ text.slide4.services[4].title }}</p>
            </div>
            <div
              class="dop overflow-hidden flex h-31.25 pt-2.5 pb-7.5">
              <div
                class="flex items-center ml-auto w-55p text-right mt-auto justify-end items-end"
              >
                <p style="line-height: 1.5625">{{ text.slide4.services[4].points[0] }} {{ text.slide4.services[4].points[1] }}</p>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
    <slide7/>
  </section>
</template>

<script>
import slide7 from "@/components/mobile/main/slide7";
import {mapMutations, mapState} from "vuex";

export default {
  name: "Agency",
  components:{
    slide7
  },
  methods:{
    ...mapMutations(['setRoute'])
  },
  computed:{
    text(){
      return {
        "slide1":{...require("@/assets/text/agency/slide1/" + this.lang + ".json")},
        "slide2":{...require("@/assets/text/agency/slide2/" + this.lang + ".json")},
        "slide3":{...require("@/assets/text/agency/slide3/" + this.lang + ".json")},
        "slide4":{...require("@/assets/text/agency/slide4/" + this.lang + ".json")}
      };
    },
    ...mapState(['lang'])
  }
}
</script>

<style scoped lang="scss">
.projects{
  h5{
    left: 0;
    color: #FF2E53;
    font-size: 1.375rem;
  }
}
.service-m {
  background: rgba(110, 117, 141, 0.1);
}
</style>
